import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

export const STATUSES = Object.freeze({
  IDLE: "idle",
  ERROR: "error",
  LOADING: "loading",
});

const getProspectWaterDetailSlice = createSlice({
  name: "getProspectWaterbodySlice",
  initialState: {
    data: {},
    statusdata: STATUSES.IDLE,
    detailData: {},
    loading: false,
  },

  extraReducers: (builder) => {
    builder

      .addCase(fetchgetProspectWaterBodyDetails.pending, (state, action) => {
        state.statusdata = STATUSES.LOADING;
        state.loading = true;
      })
      .addCase(fetchgetProspectWaterBodyDetails.fulfilled, (state, action) => {
        state.data = action.payload;
        state.statusdata = STATUSES.IDLE;
        state.loading = false;
      })
      .addCase(fetchgetProspectWaterBodyDetails.rejected, (state, action) => {
        state.statusdata = STATUSES.ERROR;
        state.loading = false;
      });
  },
});

export default getProspectWaterDetailSlice.reducer;

export const fetchgetProspectWaterBodyDetails = createAsyncThunk(
  "/fetchgetProspectWaterBodyDetails/fetch",
  async ({ id }) => {
    const token = Cookies.get("userToken");
    const config = {
      Authorization: token,
    };

    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/prospect/getProspectWaterbodyDetail/${id}`,
      {
        headers: config,
      }
    );
    const WaterBodyData = res.data;
    return WaterBodyData;
  }
);
